import AvatarDropdown from './avatar-dropdown';

export const RightContent: React.FC = () => {
  return <AvatarDropdown />;
};
